import { ConsoleView } from 'react-device-detect';
import { ActionTypes } from '../ChannelArchitecture.d';
import { reconstructBlockName } from '../utils/architecture.utils';
export const schedulesReducer = (state, { actionType, payload, saveChange }) => {
  let blockReference = ''
  switch (actionType) {
    case ActionTypes.CREATE:
      return {
        ...state,
        previous:
          state.previous.length == 0
            ? [{ item: [...state.programmes] }]
            : [...state.previous, { item: [...state.programmes] }],
        programmes: [...state.programmes, ...payload.item],
      };

    case ActionTypes.UPDATE:
      let updated = [];
      updated = state.programmes.map((item) => {
        if (item.id === payload.item.id) {
          return { ...payload.item };
        }
        return item
      });
      // }
      return {
        ...state,
        previous: [...state.previous, { item: [...state.programmes] }],
        programmes: updated,
      };

    case ActionTypes.DELETE:
      const id = payload.Id ?? payload.id
      const blockName = reconstructBlockName(payload.BlockName ?? payload.blockName);
      let deleted = []
      const removeReferenceBlocks = state.programmes.filter(
        (o) => reconstructBlockName(o.blockReference) === blockName
      );
      const updatePayloads = removeReferenceBlocks.map((value) => {
        return { item: { ...value, blockReference: '', link: false } };
      });
      deleted = state.programmes.filter((item) => item.id !== id);
      const toUpdate = deleted.map((item) => {
        if (updatePayloads.find((o) => o.item.id === item.id)) {
          const updatePayload = updatePayloads.find(
            (o) => o.item.id === item.id
          );
          return { ...updatePayload.item };
        }
        return item;
      });

      return {
        ...state,
        previous: [...state.previous, { item: [...state.programmes] }],
        programmes: toUpdate,
      };

    case ActionTypes.UPDATEALL:
      return {
        previous: !state.previous ? [] : saveChange ? [...state.previous, { item: [...state.programmes], action: 'UPDATEALL' }] : [...state.previous],
        programmes: payload.programmes,
      };
    case ActionTypes.UNDO:
      return {
        ...state,
        programmes: payload?.previous ? state.programmes : state.previous[state.previous.length - 1].item,
        previous: payload?.previous ? payload.previous : state.previous.slice(0, -1),
      };

    default:
      return state;
  }
};

export const cAModalReducer = (state, payload) => {
  const action = payload.action;
  if (action === 'changeValue') {
    const newValues = payload.newValues;
    return {
      ...state,
      ...newValues,
    };
  } else {
    const type = payload.type;
    switch (type) {
      case 'Movies':
        return {
          ...state,
          type: type,
          disableGenre: false,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: true,
          disableSeries: true,
          disablePlacement: false,
          disableTitleGroup: true,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
          sequential: false,
          series: null,
          seasons: null,
          titleGroup: null,
        };

      case 'Placeholder':
        return {
          ...state,
          type: type,
          disableGenre: true,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: true,
          disableSeries: true,
          disablePlacement: false,
          disableTitleGroup: true,
          disableLayout: false,
          disableSequential: false,
          sequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
          series: null,
          seasons: null,
          titleGroup: null,
        };

      case 'Series':
        return {
          ...state,
          type: type,
          disableGenre: false,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: false,
          disableSeries: false,
          disablePlacement: false,
          disableTitleGroup: true,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: state.series ? true : false,
          disableEndTime: false,
          disableLinkToggle: false,
          titleGroup: null,
        };

      case 'TitleGroup':
      case 'Title Group':
        return {
          ...state,
          type: type,
          disableGenre: true,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: true,
          disableSeries: true,
          disablePlacement: false,
          disableTitleGroup: false,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: state.titleGroup ? true : false,
          disableEndTime: false,
          disableLinkToggle: false,
          series: null,
          seasons: null,
        };

      case 'Repeat':
        return {
          ...state,
          type: type,
          disableGenre: true,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: state.seasons?.id ? false : true,
          disableSeries: state.series?.id ? false : true,
          disablePlacement: true,
          disableTitleGroup: state.titleGroup || state.titleGroupID ? false : true,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
        };

      default:
        return {
          ...state,
          disableGenre: false,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeries: false,
          disableTitleGroup: false,
          disableLayout: false,
          disableSequential: false,
          disableLinkReference: state.disableLinkToggle,
          disablePlacement: false,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
        };
    }
  }
};
